/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



//Disabout click
const noClickElements = document.querySelectorAll('.cursor-text');
const onClickHandler = (ev) => {
  ev.preventDefault(); ev.stopPropagation(); return false;
};
noClickElements.forEach(noClickElement => noClickElement.addEventListener('click', onClickHandler));

let textarea = document.querySelector('.gift_note_textarea');
let textareaCopy = document.querySelector('.gift-note-copy');
let current = document.querySelector('.gift_note_textarea_currentt');

if(textarea && textareaCopy && current) {
  textarea.addEventListener('keyup', function () {
    const characterCount = this.value.length;
    const max = textarea.getAttribute('maxlength');
    let remaning = max - characterCount;
    textareaCopy.value = textarea.value;
    current.textContent = remaning + " Characters Remaining";
  });
}

document.addEventListener('cart:rerendered', function(event) {
  textarea = document.querySelector('.gift_note_textarea');
  textareaCopy = document.querySelector('.gift-note-copy');
  current = document.querySelector('.gift_note_textarea_currentt');
  
  if(textarea && textareaCopy && current) {
    textarea.addEventListener('keyup', function () {
      const characterCount = this.value.length;
      const max = textarea.getAttribute('maxlength');
      let remaning = max - characterCount;
      textareaCopy.value = textarea.value;
      current.textContent = remaning + " Characters Remaining";
    });
  }
});

document.addEventListener('theme:collection:end', function (event) {

});

/* ------------------------------------------------------------------
 * YouTube iframe facade — replaces ALL YouTube iframes (including
 * those pasted into product descriptions) with a click-to-play
 * thumbnail. Cancels in-flight YouTube downloads.
 * The brand-video section in sections/video.liquid renders its own
 * facade markup directly — this code handles iframes that ended up
 * in product descriptions or elsewhere.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ytFacade) return;
  window.__ytFacade = true;

  function extractId(src) {
    if (!src) return null;
    var m = src.match(/(?:embed\/|v=|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : null;
  }

  function buildFacade(iframe) {
    var id = extractId(iframe.getAttribute('src') || iframe.dataset.ytPending || '');
    if (!id) return;

    var width = parseInt(iframe.getAttribute('width'), 10) || 560;
    var height = parseInt(iframe.getAttribute('height'), 10) || 315;

    var wrap = document.createElement('div');
    wrap.className = 'yt-lazy-wrap';
    // Aspect ratio via padding-bottom % (more reliable than CSS aspect-ratio
    // when nested inside text containers / RTE descriptions).
    wrap.style.paddingBottom = (height / width * 100) + '%';
    wrap.style.maxWidth = width + 'px';

    var link = document.createElement('a');
    link.className = 'yt-lazy';
    link.href = 'https://www.youtube.com/watch?v=' + id;
    link.dataset.ytId = id;
    link.rel = 'noopener';
    link.setAttribute('aria-label', 'Play video');

    var img = document.createElement('img');
    img.src = 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';

    var play = document.createElement('span');
    play.className = 'yt-lazy__play';
    play.setAttribute('aria-hidden', 'true');

    link.appendChild(img);
    link.appendChild(play);
    wrap.appendChild(link);

    // Walk up the DOM and replace the outermost ancestor that contains ONLY
    // this iframe (with no other meaningful content). This handles cases where
    // the iframe is wrapped in extra containers like <p> or
    // <div class="video-wrapper"> (which has its own aspect-ratio padding —
    // leaving it in place would cause double padding and a tall empty area).
    var target = iframe;
    var parent = iframe.parentElement;
    while (parent && parent.tagName !== 'BODY' && parent.tagName !== 'HTML') {
      var clone = parent.cloneNode(true);
      var ifr = clone.querySelector('iframe');
      if (ifr) ifr.remove();
      // Stop if the parent has other meaningful content
      if (clone.textContent.trim() !== '') break;
      if (clone.querySelector('img, svg, video, audio, object, embed, canvas, a[href]')) break;
      // Otherwise climb one level up
      target = parent;
      parent = parent.parentElement;
    }
    target.replaceWith(wrap);
  }

  function isYouTubeIframe(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== 'IFRAME') return false;
    // Skip iframes we just inserted via click handler — otherwise the MutationObserver
    // would see them as new YouTube iframes and immediately convert them back to facades.
    if (node.dataset && node.dataset.ytPlaying === '1') return false;
    var src = node.getAttribute('src') || '';
    return /youtube\.com\/embed|youtu\.be\//.test(src);
  }

  function processAll(root) {
    if (!root) return;
    if (isYouTubeIframe(root)) buildFacade(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('iframe').forEach(function (f) {
        if (isYouTubeIframe(f)) buildFacade(f);
      });
    }
  }

  // Process iframes already in the DOM
  processAll(document.body);

  // Catch iframes added later (AJAX, dynamic content)
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(processAll);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Click handler — load the real iframe with autoplay
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.yt-lazy');
    if (!link) return;
    e.preventDefault();
    var id = link.dataset.ytId;
    if (!id) return;
    var iframe = document.createElement('iframe');
    // Mark before setting src so MutationObserver skips this iframe when it lands in the DOM.
    iframe.dataset.ytPlaying = '1';
    iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&showinfo=0&controls=1&rel=0&modestbranding=1';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('frameborder', '0');
    // Match the absolute positioning of the .yt-lazy link so the iframe fills
    // the wrap's padded box (wrap is height:0 + padding-bottom for aspect ratio).
    iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;visibility:visible;';
    link.replaceWith(iframe);
  });
})();

/* ------------------------------------------------------------------
 * Featured Dynamic Collection — portrait video controls.
 * Replaces the per-section inline <script> that used to live in
 * sections/dynamic-featured-collection.liquid. One controller handles
 * N instances of the section on a page via event delegation + IO.
 *
 * Key behaviour:
 * - autoplay attribute is NOT set in the Liquid (changed to autoplay: false).
 *   This controller starts the video when it enters the viewport and pauses
 *   it when it leaves — so below-the-fold sections don't download their
 *   video until the user scrolls to them.
 * - User interaction (manual pause) is respected: we won't auto-resume on
 *   re-entry if the user paused it themselves.
 * - Honours prefers-reduced-motion: no autoplay, poster remains.
 * - MutationObserver picks up sections added via AJAX/section-rendering.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__featuredVideoCtrl) return;
  window.__featuredVideoCtrl = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getVideoEl(featured) {
    var v = featured.querySelector('video.featured-video, .featured-video video, .featured-video');
    if (v && v.nodeName && v.nodeName.toLowerCase() === 'video') return v;
    var mv = featured.querySelector('media-video, media-cast, deferred-media');
    if (mv && mv.shadowRoot) {
      var sv = mv.shadowRoot.querySelector('video');
      if (sv) return sv;
    }
    return featured.querySelector('video');
  }

  function setPlayIcon(btn, isPlaying) {
    if (!btn) return;
    var playIcon = btn.querySelector('.is-play');
    var pauseIcon = btn.querySelector('.is-pause');
    if (!playIcon || !pauseIcon) return;
    playIcon.hidden = !!isPlaying;
    pauseIcon.hidden = !isPlaying;
    btn.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
    btn.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  }

  function setMuteIcon(btn, isMuted) {
    if (!btn) return;
    var unmutedIcon = btn.querySelector('.is-unmuted');
    var mutedIcon = btn.querySelector('.is-muted');
    if (!unmutedIcon || !mutedIcon) return;
    unmutedIcon.hidden = !!isMuted;
    mutedIcon.hidden = !isMuted;
    btn.setAttribute('aria-pressed', isMuted ? 'true' : 'false');
    btn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
  }

  function tryPlay(video) {
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay blocked; poster remains */ });
  }

  function initFeatured(featured) {
    if (featured.__fvInit) return;
    featured.__fvInit = true;

    var video = getVideoEl(featured);
    var playBtn = featured.querySelector('.video-toggle[data-action="play"]');
    var muteBtn = featured.querySelector('.video-toggle[data-action="mute"]');
    if (!video || !playBtn || !muteBtn) return;

    // State: whether the user explicitly paused. If so, don't auto-resume on
    // scroll-back (annoying UX). Cleared when they hit play again.
    var userPaused = false;

    function syncIcons() {
      setPlayIcon(playBtn, !video.paused && !video.ended);
      setMuteIcon(muteBtn, video.muted);
    }

    if (video.readyState >= 1) syncIcons();
    else video.addEventListener('loadedmetadata', syncIcons, { once: true });

    video.addEventListener('play', function () { setPlayIcon(playBtn, true); });
    video.addEventListener('playing', function () { setPlayIcon(playBtn, true); });
    video.addEventListener('pause', function () { setPlayIcon(playBtn, false); });
    video.addEventListener('volumechange', function () { setMuteIcon(muteBtn, video.muted); });

    playBtn.addEventListener('click', function () {
      if (video.paused || video.ended) {
        userPaused = false;
        tryPlay(video);
      } else {
        userPaused = true;
        video.pause();
      }
    });

    muteBtn.addEventListener('click', function () {
      video.muted = !video.muted;
    });

    // Reduced-motion users never get autoplay. Poster stays; controls still work.
    if (prefersReducedMotion) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!userPaused && video.paused) tryPlay(video);
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: 0.25 });
      io.observe(featured);
    } else {
      // Very old browsers — just play immediately, forget the scroll pausing.
      tryPlay(video);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.featured-item[data-featured-id]').forEach(initFeatured);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (!n || n.nodeType !== 1) return;
          if (n.matches && n.matches('.featured-item[data-featured-id]')) initFeatured(n);
          else if (n.querySelectorAll) initAll(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();